import { useMessages } from '@zenbusiness/application-commons-intl';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Stack from '@zenbusiness/zui/Stack';

import { NAME } from '#client/build-env';
import { ErrorStateSection } from '#client/components/ErrorStateSection';

import { EnterpriseOrderTracker } from './components/EnterpriseOrderTracker';
import { EnterpriseProfileHeader } from './components/EnterpriseProfileHeader';
import HelpSection from './components/HelpSection';

const MESSAGE_IDS = {
  orderTrackerTitle: 'dashboard.orderTracker.title'
};

function EnterpriseHome() {
  const messages = useMessages(MESSAGE_IDS);

  return (
    <Stack spacing={{ xs: 2, sm: 3 }}>
      <ErrorBoundary
        fallback={<ErrorStateSection />}
        id={`${NAME}/pages/EnterpriseHome#EnterpriseProfileHeader`}
      >
        <EnterpriseProfileHeader />
      </ErrorBoundary>

      <ErrorBoundary
        fallback={<ErrorStateSection title={messages.orderTrackerTitle} />}
        id={`${NAME}/pages/EnterpriseHome#EnterpriseOrderTracker`}
      >
        <EnterpriseOrderTracker />
      </ErrorBoundary>

      <HelpSection />
    </Stack>
  );
}

export default EnterpriseHome;
